import { render, staticRenderFns } from "./MouseScroll.vue?vue&type=template&id=143d7b74&scoped=true&"
var script = {}
import style0 from "./MouseScroll.vue?vue&type=style&index=0&id=143d7b74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143d7b74",
  null
  
)

export default component.exports